import { BASE_BE_URL } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import {
  ALMSG_INTERNAL_ERR,
  ALMSG_UNAUTHORIZED_OP,
  BASE_PAY_SUBURL,
} from "../env";

export interface SubscriptionPaymentUrl {
  url: string;
  error: string;
}

export async function startPaymentProcess(
  signedInDoctor: SignedInDoctor,
  subscriptionId: number
): Promise<SubscriptionPaymentUrl> {
  try {
    //console.log("Create patient with data ", JSON.stringify(newPatient));
    const response = await fetch(BASE_BE_URL + BASE_PAY_SUBURL + "subscribe", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + signedInDoctor.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ subscriptionId: subscriptionId }),
    });

    if (response.ok)
      return { url: (await response.json()).orderLink, error: "" };

    if (response.status == 400)
      return { url: "", error: (await response.json()).message };
    else if (response.status == 401)
      return { url: "", error: ALMSG_UNAUTHORIZED_OP };
    else return { url: "", error: ALMSG_INTERNAL_ERR };
  } catch (error: any) {
    return { url: "", error: ALMSG_INTERNAL_ERR };
  }
}
